export const filesSizes = (values, fileSizeMax) => {
  if (values && values.length && values[0] && values[0].length) {
    for (let i = 0; i < values[0].length; i++) {
      if (values && values[0][i].size >= fileSizeMax) {
        return false
      }
    }
  }

  return true;
};

export const filesType = (values, fileTypes) => {
  if (values && values.length && values[0] && values[0].length) {
    for (let i = 0; i < values[0].length; i++) {
      if (values && fileTypes.includes(values[0][i].type)) {
        return false
      }
    }
  }

  return true;
};

export const fileNameValidation = value => {
  if (! value) {
    return false;
  }

  // the file name shouldn't be only .(dot)
  if (value.length === 1 && value.indexOf(".") !== -1) {
    return false;
  }

  // forbidden chars from a filename in Windows OS
  const forbiddenChars = ['<', '>', ':', '"', '/', '\\', '|', '?', '*', ];
  let char = 0;

  for (char in value) {
    if (forbiddenChars.indexOf(value.charAt(char)) !== -1) {
      return false;
    }

    if (value.charCodeAt(char) >= 1 && value.charCodeAt(char) <= 31) {
      return false;
    }
  }

  return true;
}
